export enum AnalyticsPeriod {
    Day = "Day",
    Month = "Month"
}

export const AnalyticsPeriodUtil = {
    getStringValue: (period: AnalyticsPeriod | null | undefined): string => {
        switch (period) {
            case AnalyticsPeriod.Day:
                return "День";
            case AnalyticsPeriod.Month:
                return "Месяц";
            default:
                return "";
        }
    }
};

